var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJetbrains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 62.637,
    y1: 55.039,
    x2: 97.248,
    y2: 34.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcee39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37b3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 69.954,
    y1: 4.885,
    x2: 101.543,
    y2: 32.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef5a6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f26f4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f37b3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 71.961,
    y1: 29.953,
    x2: 53.24,
    y2: 18.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c59a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#af4c92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#dc4183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#ed3d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 71.622,
    y1: 3.472,
    x2: 53.345,
    y2: 18.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef5a6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ee4e72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed3d7d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.114332 0 0 1.114332 -51.712607 -2.053351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.97 33.542a2.039 2.039 0 0 0 .664-1.414 2.064 2.064 0 0 0-1.943-2.163 2.157 2.157 0 0 0-1.458.485L61.236 50.712a4.336 4.336 0 0 0-2.074 1.809 4.445 4.445 0 0 0 1.595 6.136 4.541 4.541 0 0 0 4.722-.089c.09-.09.22-.134.32-.22l34.404-24.2a5.61 5.61 0 0 0 .75-.619z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.042 30.584L72.89 2.948a3.405 3.405 0 0 0-5.916 2.294 3.382 3.382 0 0 0 .916 2.345 4.675 4.675 0 0 0 .533.437l29.755 25.473a2.275 2.275 0 0 0 1.324.574 2.064 2.064 0 0 0 2.163-1.943 2.205 2.205 0 0 0-.622-1.544z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.805 28.11c-.045 0-17.393-13.686-17.748-13.906l-.795-.4a4.939 4.939 0 0 0-4.327 8.829 3.893 3.893 0 0 0 .884.399c.175.09 20.042 8.296 20.042 8.296a1.895 1.895 0 0 0 1.943-3.223z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36 1.844a3.596 3.596 0 0 0-2.029.664l-17.57 11.83c-.045.045-.09.045-.09.09h-.045a4.92 4.92 0 0 0 1.193 8.615 4.844 4.844 0 0 0 4.592-.619 4.126 4.126 0 0 0 .795-.705L72.48 7.942a3.411 3.411 0 0 0 1.324-2.693 3.44 3.44 0 0 0-3.446-3.405z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.319087 0 0 .319087 11.305442 -9.323765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.74 86.74h70.56v70.56h-70.56z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.82 144.02h26.43v4.43h-26.43zm-.27-38.74l2.08-1.94a2.36 2.36 0 0 0 1.8 1.11q1.25 0 1.25-1.66v-7.33h3.18v7.33a3.87 3.87 0 0 1-4.29 4.29 4.19 4.19 0 0 1-4.02-1.8zm9-9.68h9.27v2.63h-6.1V100h5.53v2.5h-5.53v1.8h6.23v2.77h-9.27zM193 98.36h-3.5V95.6h10.1v2.77h-3.46v8.72H193zm-22.18 11.34h5.95a5.12 5.12 0 0 1 3.18 1 2.74 2.74 0 0 1 .69 1.94 2.71 2.71 0 0 1-1.8 2.63 2.69 2.69 0 0 1 2.21 2.77c0 1.94-1.66 3.18-4.3 3.18h-5.95zm6.64 3.6c0-.7-.55-1-1.38-1H174v2.08h1.94c1-.14 1.52-.42 1.52-1.1zm-1.1 3.32h-2.5v2.08h2.5c1 0 1.52-.42 1.52-1.1.01-.7-.54-.97-1.5-.97zm5.24-6.92h5.4a4.86 4.86 0 0 1 3.74 1.25 3.44 3.44 0 0 1 1 2.63 3.82 3.82 0 0 1-2.35 3.6l2.77 4h-3.6l-2.35-3.46h-1.4v3.46h-3.18zm5.26 5.53c1.1 0 1.66-.55 1.66-1.38 0-1-.7-1.38-1.66-1.38h-2.07v2.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.45 109.7h3l4.84 11.62h-3.46l-.83-2.08h-4.43l-.83 2.08h-3.32zm2.77 6.92l-1.22-3.18-1.25 3.18zm5.53-6.92h3.18v11.48h-3.18zm4 0h2.9l4.7 6.1v-6.1h3.18v11.48h-2.77l-4.83-6.2v6.36h-3.18zm11.07 9.83l1.8-2.08a5.45 5.45 0 0 0 3.74 1.38c.83 0 1.38-.28 1.38-.83s-.42-.7-1.94-1.1c-2.5-.55-4.3-1.25-4.3-3.6 0-2.08 1.66-3.74 4.43-3.74a7.38 7.38 0 0 1 4.7 1.52L227 113.3a6.3 6.3 0 0 0-3.18-1.11c-.83 0-1.1.28-1.1.7 0 .55.42.7 1.94 1.1 2.63.55 4.3 1.38 4.3 3.6 0 2.35-1.8 3.74-4.7 3.74a7.32 7.32 0 0 1-5.41-1.81z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetbrains);
export default __webpack_public_path__ + "static/media/jetbrains.92906418fa6e42f65067337af7f7e3e2.svg";
export { ForwardRef as ReactComponent };